import { IColumn } from "@fluentui/react";
import TableSelectRow from "../../../../../dto/Form/TableSelectRow";

export default class TableSelectState {
    public hoveringSelectAll: boolean = false;
    public columns: IColumn[] = [];
    public rows: TableSelectRow[] = [];
    public selectedRows: string[] = [];
}